import { useState } from "react";
import type { CloudConfig } from "../../api/types";

export function ConfigEditor({
  draft,
  setDraft,
  disableWorkspace,
}: {
  draft: Partial<CloudConfig>;
  setDraft: (updater: (prev: Partial<CloudConfig>) => Partial<CloudConfig>) => void;
  disableWorkspace?: boolean;
}) {
  const [showInfo, setShowInfo] = useState<any>(null);
  const allModels = window.config?.models || [];

  return (
    <div className="cfg-table">
      {Object.entries(draft).map(([k, v]) => (
        <div className="rowi" key={k}>
          <label>{k}</label>
          {k === "language" ? (
            <select
              className="input"
              style={{ width: "100%" }}
              value={String(v)}
              onChange={(e) => setDraft((d) => ({ ...d, [k]: e.target.value }))}
            >
              <option value="de">de</option>
              <option value="en">en</option>
            </select>
          ) : k === "model" || k === "subagent_model" || k === "planner_model" || k === "critique_model" || k === "image_model" ? (
            <div style={{ display: "flex", width: "100%", gap: "6px", alignItems: "center" }}>
              <select
                className="input"
                style={{ flex: 1 }}
                value={String(v)}
                onChange={(e) => setDraft((d) => ({ ...d, [k]: e.target.value }))}
              >
                {String(v) && !allModels.some((m) => m.ID === String(v)) && (
                  <option value={String(v)}>{String(v)}</option>
                )}
                {allModels.map((m) => (
                  <option key={m.ID} value={m.ID}>
                    {m.label}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="btn ghost"
                style={{
                  padding: "2px 6px",
                  fontSize: "0.85rem",
                  minWidth: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1
                }}
                onClick={() => {
                  const currentModel = allModels.find((m) => m.ID === String(v));
                  if (currentModel) {
                    setShowInfo(currentModel);
                  }
                }}
                title="Modell-Details anzeigen"
              >
                ?
              </button>
            </div>
          ) : typeof v === "boolean" ? (
            <label className="switch">
              <input
                type="checkbox"
                checked={v}
                onChange={(e) => setDraft((d) => ({ ...d, [k]: e.target.checked }))}
                aria-label={k}
              />
              <span className="tr" />
            </label>
          ) : (
            <input
              type="text"
              value={typeof v === "object" && v !== null ? JSON.stringify(v) : String(v)}
              disabled={disableWorkspace && k === "workspace"}
              onChange={(e) => {
                const raw = e.target.value;
                let parsed: unknown = raw;
                if (typeof v === "object" && v !== null) {
                  try {
                    parsed = JSON.parse(raw);
                  } catch {
                    parsed = raw;
                  }
                } else if (typeof v === "number") {
                  const num = Number(raw);
                  if (!isNaN(num)) parsed = num;
                }
                setDraft((d) => ({ ...d, [k]: parsed }));
              }}
            />
          )}
        </div>
      ))}

      {showInfo && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10000,
          padding: "16px"
        }} onClick={() => setShowInfo(null)}>
          <div style={{
            backgroundColor: "var(--surface)",
            color: "var(--c-text)",
            border: "1px solid var(--line)",
            borderRadius: "12px",
            width: "100%",
            maxWidth: "480px",
            padding: "24px",
            boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
              <h3 style={{ margin: 0, fontSize: "1.15rem" }}>{showInfo.label}</h3>
              <button type="button" className="btn ghost" style={{ minWidth: 0, padding: "4px 8px" }} onClick={() => setShowInfo(null)}>✕</button>
            </div>
            <div style={{ fontSize: "0.95rem", lineHeight: "1.5", marginBottom: "16px", whiteSpace: "pre-wrap" }}>
              {showInfo.description}
            </div>
            <div style={{ fontSize: "0.85rem", color: "var(--muted)", borderTop: "1px solid var(--line)", paddingTop: "12px" }}>
              <div><strong>Anbieter (Vendor):</strong> {showInfo.provider}</div>
              <div style={{ marginTop: "4px" }}><strong>Kosten (Cost):</strong> {showInfo.cost}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
